import React, { useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { useRecoilValue } from "recoil";
import { advancedSearch } from "../../shared/advancedSearch";
import { useEffect } from "react";
import { API } from "../../services/apiConfig";
import MyChart from "../Chart/Chart";
import Typography from "../Typography/Typography";
import { separate } from "../../utils/separate";
import Loading from "../Loadings/LoadingTable";

export const SellChartModal = ({ show, handleClose }) => {
  const [button] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const sellChartProperties = useRecoilValue(advancedSearch);
  const IdUser = JSON.parse(localStorage.getItem("profile"))?.users[0]?.IdUser;
  const fetchChart = async () => {
    setLoading(true);
    await API.post("/UnitCRM/Chart/ShowChartListFiles", {
      ...sellChartProperties,
      IdUser,
    }).then((res) => {
      setData(res?.data);
      setLoading(false);
    });
  };
  useEffect(() => {
    if (show) {
      fetchChart();
    }
  }, [show]);
  console.log(data);
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        intersect: false,
      },
      title: {
        display: true,
        text: "نمودار فروش",
      },
    },
  };
  const labels = ["تعداد پرونده", "تعداد فروش"];
  const chartData = {
    labels,
    datasets: [
      {
        label: "فروش",
        data: [data?.Numbersales_opportunities, data?.count],
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "خرید انجام شده",
        data: [data?.parvandeh],
        backgroundColor: "rgba(52, 151, 135, 0.5)",
      },
    ],
  };

  return (
    <BootstrapModal
      modaltitle="نمودار فروش"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="lg"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      {loading ? (
        <Loading />
      ) : (
        <>
          <MyChart
            data={chartData}
            sell={"نمودار فروش"}
            options={options}
            labels={labels}
          />

          <div className="flex justify-evenly between">
            <Typography className="font-bold text-center">
              جمع فروش: {separate(data?.sum)}
            </Typography>
            <Typography className="font-bold text-center">
              نرخ تبدیل: {(+data?.exchange_rate)?.toString()?.substring(0, 5)}
            </Typography>
          </div>
        </>
      )}
    </BootstrapModal>
  );
};
